import { createTemplateTag, extractValueWithPath } from 'function-tree';
import { getRootPath, DEPRECATE } from '../utils';
export { createTemplateTag, extractValueWithPath, resolveObject, ResolveValue, Tag } from 'function-tree';

export var string = createTemplateTag('string', function (path) {
  return path;
});

export var path = createTemplateTag('path', function (path) {
  return path;
});

export var signal = createTemplateTag('signal', function (path, context) {
  DEPRECATE('tags.signal', 'use the "sequences" tag instead');
  return context.controller.getSequence(path);
});

export var signals = createTemplateTag('signals', function (path, context) {
  DEPRECATE('tags.signals', 'use the "sequences" tag instead');
  return context.controller.getSequences(path);
});

export var sequences = createTemplateTag('sequences', function (path, context) {
  return context.controller.getSequence(path) || context.controller.getSequences(path);
});

export var state = createTemplateTag('state', function (path, context) {
  return context.controller.getState(path);
});

export var module = createTemplateTag('module', function (path, context) {
  DEPRECATE('tags.module', 'use the "moduleState" tag instead');
  return context.controller.getState(getRootPath(path, context));
});

export var moduleState = createTemplateTag('moduleState', function (path, context) {
  return context.controller.getState(getRootPath(path, context));
});

export var moduleSequences = createTemplateTag('moduleSequences', function (path, context) {
  return context.controller.getSequence(getRootPath(path, context)) || context.controller.getSequences(getRootPath(path, context));
});

export var props = createTemplateTag('props', function (path, context) {
  return extractValueWithPath(context.props, path);
});
//# sourceMappingURL=index.js.map